import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Extensions temporarily re-enabled during gradual migration
// import './app/extension/date.extensions';
// import './app/extension/array.extensions';
// import './app/extension/string.extensions';
// import './app/extension/number.extensions';


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
